import axios from "axios";
import store from "../store";
import { LOGOUT_REQ } from "../actions";
import { HTTP_UNAUTHORIZED_STATUS } from "../constants/http_constants";
import { toast } from "react-toastify";
import { login } from "./routers";

// "master/region" is the literal URL used in sagas/auth.js — it does not
// reuse the `region` export from routers.js (which has a leading slash).
const SKIP_REGION_CODE_ROUTES = [login, "master/region"];

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.withCredentials = true;

const setUser = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  let token = "Bearer " + localStorage.getItem("token");
  if (user && token) axios.defaults.headers.common["Authorization"] = token;
};

const clearUser = () => {
  delete axios.defaults.headers.common["Authorization"];
};
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  let token = "Bearer " + localStorage.getItem("token");
  config.headers.Authorization = token;

  if (SKIP_REGION_CODE_ROUTES.includes(config.url)) return config;

  const paramsRegion = config["region-code"];
  const localRegion = localStorage.getItem("region_code");
  const region_code = paramsRegion || localRegion;

  config.params = config.params
    ? { "region-code": region_code || "apac-staging", ...config.params }
    : { "region-code": region_code || "apac-staging" };

    // console.log("Request Config:", config);
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response.status === HTTP_UNAUTHORIZED_STATUS &&
      store.getState().user.isSessionActive
    ) {
      console.log(error);
      toast.warning("Your session has expired! Please login again.");
      store.dispatch(LOGOUT_REQ());
    }
    return Promise.reject(error);
  }
);

// Make a request for a common get records

const axiosGet = (url, options) =>
  axios
    .get(url, options)
    .then(function (response) {
      // handle success
      return response;
    })
    .catch(function (error) {
      // handle error
      return error.response || error;
    });

// Make a request for a common post records
const axiosPost = (url, payload, options) =>
  axios
    .post(url, payload, options)
    .then(function (response) {
      // handle success
      return response;
    })
    .catch(function (error) {
      // handle error
      return error.response || error;
    });

// Make a request for a common put records
const axiosPut = (url, payload, options) =>
  axios
    .put(url, payload, options)
    .then(function (response) {
      // handle success
      return response;
    })
    .catch(function (error) {
      // handle error
      return error.response || error;
    });

// Make a request for a common patch records
const axiosPatch = (url, payload, options) =>
  axios
    .patch(url, payload, options)
    .then((response) => response)
    .catch((error) => error.response || error);

// Make a request for a common delete records
const axiosDelete = (url, options) =>
  axios
    .delete(url,options)
    .then(function (response) {
      // handle success
      return response;
    })
    .catch(function (error) {
      // handle error
      return error.response || error;
    });

export {
  axios,
  axiosGet,
  axiosPost,
  axiosPut,
  axiosPatch,
  axiosDelete,
  setUser,
  clearUser,
};
